import { Box } from '@mui/material'
import { CustomStyles, getStyles, STYLE_SIZE_CONSTANTS } from '@utils/styles'
import defaultStyles, { StylesClassNames } from './styles'

export type Props = {
  children: React.ReactNode
  className?: string
  direction?: 'row' | 'row-reverse'
  stickyElement?: React.ReactNode
  csx?: CustomStyles<StylesClassNames>
  additionalTopSpace?: number
  isIntroSectionVisible?: boolean
  compact?: boolean
}

export function WrapperWithAsideStickySection({
  children,
  direction = 'row',
  csx,
  stickyElement,
  additionalTopSpace = 0,
  isIntroSectionVisible = false,
  compact = true,
}: Props) {
  const styles = getStyles(defaultStyles, csx, {
    wrapper: { flexDirection: direction },
  })

  return (
    <Box
      {...styles('wrapper', {
        maxWidth: compact ? STYLE_SIZE_CONSTANTS.sectionMaxWidth : undefined,
        padding: compact ? STYLE_SIZE_CONSTANTS.sectionPadding : undefined,
      })}
    >
      {stickyElement && (
        <Box
          component="aside"
          {...styles('stickySection', {
            // ...(shouldStickFromTop
            //   ? { top: STYLES_SIZE_CONSTANTS.headerHeight + 16 }
            //   : { marginTop: 'auto', bottom: 16 }),
            top:
              STYLE_SIZE_CONSTANTS.headerHeight +
              16 +
              additionalTopSpace +
              (isIntroSectionVisible
                ? STYLE_SIZE_CONSTANTS.overViewHeaderHeight
                : 0),

            transition: 'all 0.3s ease-in-out',
          })}
        >
          {stickyElement}
        </Box>
      )}
      {children}
    </Box>
  )
}
